import {useSelector} from "react-redux";
import {useEffect, useMemo, useState} from "react";
import {flatten} from "../../ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/utils/flatternArray";

/**
 * This hook is used for detecting errors in parent component
 *
 * for ex.
 *
 * If an accordion or tab is not active (collapsed), this hook detects whether there are any fields
 * with errors inside it.
 * If errors are found, the accordion or tab should be visually highlighted to alert the user.
 *
 * **/

const useFieldErrors = (children) => {
    const [errCount, setErrCount] = useState(0);
    const forms = useSelector(state => state.jsonScreen.forms);

    const childFields = useMemo(() => {
        return flatten(children, x => x.children)
            .filter(o => o.type === 'field' && o.properties && o.properties.path !== undefined)
            .map(field => {
                return field.properties.arrayPath ? field.properties.arrayPath : field.properties.path
            });
    }, [JSON.stringify(children)]);


    useEffect(() => {
        try {
            let errs = [];
            const seen = new Set();
            childFields.map(f => {
                if(!f) return;

                let parts = f.split('.');
                let entity = parts[0];
                let childField = parts.slice(1).join(".");
                if (entity) {
                    let formErrors = forms[entity]?.status?.message || [];
                    formErrors.forEach(fe => {
                        const uniqueKey = `${entity}.${fe.field}`; // Unique identifier
                        if (fe.field === childField && !seen.has(uniqueKey)) {
                            seen.add(uniqueKey);
                            errs.push(fe);
                        }
                    });
                }
            })

            setErrCount(errs.length)
        } catch (e) {
            console.log(e)
        }
    }, [JSON.stringify(childFields), JSON.stringify(forms)]);

    return {errCount}
}

export default useFieldErrors;